import { useNavigate } from 'react-router-dom';
import { Eye, X } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';

/**
 * Faixa fixa exibida enquanto um master/parceiro navega impersonando um cliente.
 * Deixa explícito que você NÃO está na sua conta e oferece encerrar com 1 clique.
 */
export function ImpersonationBanner() {
  const navigate = useNavigate();
  const impersonatedBy = useAuthStore(s => s.impersonatedBy);
  const stopImpersonation = useAuthStore(s => s.stopImpersonation);

  if (!impersonatedBy) return null;

  function onExit() {
    const restored = stopImpersonation();
    // Volta pra origem do operador: master → tenants, parceiro → /parceiro.
    navigate(restored ? (impersonatedBy!.kind === 'master' ? '/admin/tenants' : '/parceiro') : '/login', { replace: true });
  }

  return (
    <div className="flex items-center justify-center gap-3 bg-amber-500 px-4 py-1.5 text-sm font-medium text-amber-950">
      <Eye className="h-4 w-4 shrink-0" />
      <span>
        Você está visualizando como <strong>cliente</strong>. Alterações afetam a conta dele.
      </span>
      <button
        onClick={onExit}
        className="inline-flex items-center gap-1 rounded-md bg-amber-950/10 px-2 py-0.5 text-xs font-semibold hover:bg-amber-950/20"
      >
        <X className="h-3.5 w-3.5" /> Encerrar
      </button>
    </div>
  );
}
